import { VButton } from '../VButton';
import { VChip } from '../VChip';
import { VFlex } from '../VFlex';
import { usePickListContext } from './hook';
import style from './style';
import type { BaseItem } from './type';

type VPickedItemListProps = {
  pickedItemListTitle?: string;
  confirmButtonText?: string;
  onConfirm?: (items: BaseItem[]) => void;
};

const VPickedItemList = ({
  pickedItemListTitle,
  confirmButtonText,
  onConfirm,
}: VPickedItemListProps) => {
  const { innerPickedItems, toggleItem } = usePickListContext();

  const onClick = () => {
    onConfirm?.(innerPickedItems);
  };

  return (
    <VFlex className={style.pickedItemListContainer}>
      <VFlex className={style.pickedItemList}>
        <div className={style.pickedItemListTitle}>
          {pickedItemListTitle || 'Picked Items'}
        </div>

        <div className={style.pickedItemContentsWrapper}>
          <VFlex className={style.pickedItemContents}>
            {innerPickedItems.map(item => {
              return (
                <VChip key={item.value} onDelete={() => toggleItem(item)}>
                  {item.value}
                </VChip>
              );
            })}
          </VFlex>
        </div>
      </VFlex>

      <VButton size="md" onClick={onClick}>
        {confirmButtonText || '+'}
      </VButton>
    </VFlex>
  );
};

export default VPickedItemList;
